export default {"src":"https://cp-landing.wukongedu.net/_next/static/media/logo-math.b1599171.svg","height":40,"width":120,"blurWidth":0,"blurHeight":0};